import { mapState } from "vuex";
import currentTemplatesMixin from "@/mixins/currentTemplates";
import documentModelMixin from "@/mixins/documentModel";
import contentBlocks from "@/services/sharedo/contentBlocksService";
import contentBlockTags from "@/services/word/contentBlockTagsService";
import customProperties from "@/services/word/customPropertiesService";
import htmlContentBlocks from "@/services/word/htmlContentBlocksService";
import { HtmlContentBlock, ContentBlock } from "@/models/documentModel";
import {
    CONTENT_BLOCK_DOCUMENT,
    CONTENT_BLOCK_HTML,
} from "@/constants/templateTypes";

const modalClosed = async function (args = {}) {
    const vm = this;

    const { reload } = args;
    vm.showContentBlockModal = false;
    vm.currentBlock = null;

    if (reload && !!vm.reload) {
        await vm.reload();
    }
};

const ruleModalClosed = function () {
    const vm = this;

    vm.showRuleModal = false;
    vm.currentBlock = null;
};

const insertContentBlock = async function (contentBlock) {
    this.logDebug("Inserting content block", { contentBlock });
    const vm = this;

    try {
        const model = vm.documentModel;

        const { id, parentId } = await htmlContentBlocks.add(
            contentBlock.systemName,
            contentBlock.htmlContent,
            contentBlock.title,
            this.boundingBoxesHidden
        );

        const htmlContentBlock = new HtmlContentBlock(
            id,
            contentBlock.systemName,
            contentBlock.title,
            {
                number: contentBlock.versionNumber,
                date: contentBlock.versionDate,
            }
        );

        if (parentId) {
            const parent = model.findContentControl(parentId);
            parent.contentControls.push(htmlContentBlock);
        } else {
            model.contentControls.push(htmlContentBlock);
        }

        await vm.saveDocumentModel(model);
        this.logDebug("Saved document model.", model);

        const sharedoId = await customProperties.get("SharedoActivityId");
        if (sharedoId && vm.currentTemplates.length > 0) {
            const template = vm.currentTemplates[0];
            await contentBlocks.markAsUsed(contentBlock, sharedoId, template);
            this.logInfo("Content block marked as used.", { contentBlock, sharedoId, template });
        }

        this.logDebug("Content block inserted.", { contentBlock: htmlContentBlock });

        vm.showContentBlockModal = false;
        vm.currentBlock = null;
    } catch (error) {
        this.logError("Error inserting content block.", { contentBlock, error });
        throw error;
    }
};

const insertContentBlockAsTag = function (contentBlock) {
    this.logDebug("Inserting conent block as a tag.", { contentBlock })
    const vm = this;

    vm.currentBlock = contentBlock;
    vm.showContentBlockModal = false;
    vm.showRuleModal = true;
};

const ruleSelected = async function (businessRuleId) {
    this.logDebug("Display rule selected.", { displayRuleId: businessRuleId });

    const vm = this;

    try {
        const contentBlock = vm.currentBlock;
        const model = vm.documentModel;
        const { id, parentId } = await contentBlockTags.add(
            contentBlock.systemName,
            contentBlock.title,
            this.boundingBoxesHidden
        );

        let contentBlockItem

        if (contentBlock.templateType === CONTENT_BLOCK_DOCUMENT) {
            contentBlockItem = new ContentBlock(id, contentBlock.systemName, contentBlock.title, null, businessRuleId);
        } else {
            contentBlockItem = new ContentBlock(
                id,
                contentBlock.systemName,
                contentBlock.title,
                {
                    number: contentBlock.versionNumber,
                    date: contentBlock.versionDate,
                },
                businessRuleId
            );
        }

        if (parentId) {
            const parent = model.findContentControl(parentId);
            parent.contentControls.push(contentBlockItem);
        } else {
            model.contentControls.push(contentBlockItem);
        }

        await vm.saveDocumentModel(model);
        this.logDebug("Document model saved.", model);

        this.logDebug("Content block inserted as tag.", { contentBlock, contentControlId: id });

        vm.showRuleModal = false;
        vm.currentBlock = null;
    } catch (error) {
        this.logError("Error inserting content block.", { contentBlock: vm.currentBlock, displayRuleId: businessRuleId, error });
        throw error;
    }
};

const mixin = {
    mixins: [documentModelMixin, currentTemplatesMixin],
    data: function () {
        return {
            currentBlock: null,
            showRuleModal: false,
            showContentBlockModal: false,
        }
    },
    computed: {
        ...mapState({
            boundingBoxesHidden: (state) => state.boundingBoxesHidden,
        }),
    },
    methods: {
        modalClosed,
        ruleModalClosed,
        insertContentBlock,
        insertContentBlockAsTag,
        ruleSelected
    }
}

export default mixin;